import React from 'react';
import ContactPage from '../components/contact';

export default function Contact() {
    return (
        <div>
            <ContactPage />
        </div>
    )
}